angular.module('industry-type')
    .directive('industryTypePicker', function (IndustryType, IndustryTypeService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: false,
            scope: {
                required: "=",
                onChange: "&",
                filterField: "=?",
                modelType: "=?",
                disableList: "=?",
                disableAdd: "=?"
            },
            templateUrl: "app/industry-type/picker/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.filterStyle = scope.filterField || false
                scope.modelType = scope.modelType || "object"
                scope.disableList = scope.disableList || false
                scope.disableAdd = scope.disableAdd || false

                scope.executeOnChange = scope.onChange || angular.noop
                loadItems()

                function loadItems(){
                    IndustryType.autocomplete().$promise.then(items => scope.items = items)
                }

                scope.add = () => IndustryTypeService.add().then(() => loadItems())
                scope.list = () => IndustryType.autocomplete().then(() => loadItems())

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelType === "id" ? viewValue.id : viewValue)

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
    .component('industryTypePickerMultiple', {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            required: "=",
            modelType: '<',
            onChange: "&"
        },
        templateUrl: "app/industry-type/picker/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function ($scope, $element, $attrs, IndustryType, uiSelectFix) {
            let ctrl = this
            ctrl.uiSelectFix = uiSelectFix

            ctrl.$onInit = () => {
                ctrl.executeOnChange = ctrl.onChange || angular.noop
                ctrl.modelTypeR = ctrl.modelType || "object"
                IndustryType.autocomplete().$promise.then(items => ctrl.items = formatAndMap(items))
            }

            ctrl.$onChanges = () => { //changes from parent controller
                ctrl.selected = formatAndMap(ctrl.ngModel)
                ctrl.ngChange()
            }
            ctrl.ngChange = () => ctrl.ngModel = ctrl.selected

            function formatAndMap (items){
                if(!angular.isArray(items)){
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        },
    })
